import type { Language, LanguageEntry } from "./Languages";

export function selectDefaultLanguage(languages: readonly string[]): Language {
  return languages.some(
    (language) =>
      language.replaceAll("_", "-").toLowerCase().split("-")[0] === "zh",
  )
    ? ("zh-Hans" as Language)
    : ("en" as Language);
}

export function selectValidLanguage(
  language: unknown,
  languages: Record<string, LanguageEntry>,
  browserLanguages: readonly string[],
): Language {
  return typeof language === "string" && Object.hasOwn(languages, language)
    ? (language as Language)
    : selectDefaultLanguage(browserLanguages);
}
